import type { CompleteUser } from '../types';

export function canManageAccountSettings(
  user: Pick<CompleteUser, 'accessLevel'> | null | undefined
): boolean {
  return user?.accessLevel === 'OWNER' || user?.accessLevel === 'ADMIN';
}
